export let APP_SETTINGS = {
    version: '',
    company: 'Genesis Trailers'
};
